import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

declare var gtag: Function;

@Injectable({
    providedIn: 'root',
})

export class GoogleAnalyticsService {

    constructor() {
    }

    public initialize(id: any): void {
        // dynamically add analytics scripts to document head
        try {
            const existingGTagScript: HTMLElement | null = document.getElementById('gTagScript' + id)
            const url: string = 'https://www.googletagmanager.com/gtag/js?id=';
            if (!existingGTagScript) {
                const gTagScript: HTMLScriptElement = document.createElement('script');
                gTagScript.setAttribute('id', 'gTagScript' + id)
                gTagScript.setAttribute('class', 'customAnalytics')
                gTagScript.async = true;
                gTagScript.src = `${url}${id}`;
                document.head.prepend(gTagScript);
            }

            const existingDataLayerScript: HTMLElement | null = document.getElementById('GoogleAnalyticsDataLayerScript')
            if (existingDataLayerScript && !existingDataLayerScript.innerHTML.includes(id)) {
                // GA Already setup and doesnt include current id
                existingDataLayerScript.innerHTML = existingDataLayerScript.innerHTML + `gtag('config', '${id}');`
            } else if (!existingDataLayerScript) {
                // No GA setup yet
                const dataLayerScript: HTMLScriptElement = document.createElement('script');
                dataLayerScript.setAttribute('id', 'GoogleAnalyticsDataLayerScript')
                dataLayerScript.setAttribute('class', 'customAnalytics')
                dataLayerScript.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('set', 'user_properties', {
                platform: '${localStorage.getItem('isApp') ? 'App' : 'Web'}'});
                gtag('config', '${id}');`
                document.head.appendChild(dataLayerScript);
            }
        } catch (e) {
            console.error('Error adding Google Analytics', e);
        }

    }


    public remove(): void {
        //     Remove GA Stuff to not use ga from last community
        const existingGTagScripts: HTMLCollectionOf<Element> | null = document.getElementsByClassName('customAnalytics')
        const elementsArray: Element[] = Array.from(existingGTagScripts);
        elementsArray.forEach(element => {
            if (element.id !== 'gTagScript' + environment.masterGaId) {
                element.remove();
            }
        });
        const existingDataLayerScript: HTMLElement | null = document.getElementById('GoogleAnalyticsDataLayerScript')
        if (existingDataLayerScript && environment.masterGaId) {
            // Never remove the masterGaId if it exists
            existingDataLayerScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('set', 'user_properties', {
            platform: '${localStorage.getItem('isApp') ? 'App' : 'Web'}'});
            gtag('config', '${environment.masterGaId}');`
        } else {
            existingDataLayerScript?.remove()
        }
    }

    // use gtag.js to send Google Analytics Events
    public event(action: string, eventCategory?: string, eventLabel?: string, value?: string): void {
        gtag('event', action, {
            ...(eventCategory && {event_category: eventCategory}),
            ...(eventLabel && {event_label: eventLabel}),
            ...(value && {value: value}),
        });
    }
}
